module.exports = __webpack_public_path__ + "static/media/lock.280fbd70.svg";